export enum TwoFaActionType {
  ENABLE_TFA = 'enable2Fa',
  DISABLE_TFA = 'disable2Fa',
  CREATE_RECOVERY_KEY = 'createRecoveryKey'
}
